/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "动机(Motivation)"
    }), "\n", _jsx(_components.p, {
      children: "¥Motivation"
    }), "\n", _jsx(_components.p, {
      children: "styled-components 是我们想知道如何增强 CSS 来设计 React 组件系统的结果。通过专注于单个用例，我们成功地优化了开发者的体验以及终端用户的输出。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "styled-components is the result of wondering how we could enhance CSS for styling React component systems."
      }), " By focusing on a single use case we managed to optimize the experience for developers as well as the output for end users."]
    }), "\n", _jsx(_components.p, {
      children: "除了改善开发者的体验之外，样式组件还提供："
    }), "\n", _jsx(_components.p, {
      children: "¥Apart from the improved experience for developers, styled-components provides:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "自动关键 CSS：styled-components 完全自动地跟踪页面上渲染的组件并注入它们的样式，而不是其他任何东西。与代码分割相结合，这意味着你的用户加载所需的代码量最少。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Automatic critical CSS"
          }), ": styled-components keeps track of which components are rendered on a page and injects their styles and nothing else, fully automatically. Combined with code splitting, this means your users load the least amount of code necessary."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "没有类名错误：styled-components 为你的样式生成唯一的类名称。你永远不必担心重复、重叠或拼写错误。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "No class name bugs"
          }), ": styled-components generates unique class names for your styles. You never have to worry about duplication, overlap or misspellings."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "更轻松地删除 CSS：很难知道代码库中的某个位置是否使用了类名。styled-components 使其变得显而易见，因为每个样式都与特定组件相关联。如果组件未使用（工具可以检测到）并被删除，则其所有样式都会随之删除。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Easier deletion of CSS"
          }), ": it can be hard to know whether a class name is used somewhere in your codebase. styled-components makes it obvious, as every bit of styling is tied to a specific component. If the component is unused (which tooling can detect) and gets deleted, all its styles get deleted with it."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "简单的动态样式：根据组件的 props 或全局主题调整组件的样式既简单又直观，无需手动管理数十个类。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Simple dynamic styling"
          }), ": adapting the styling of a component based on its props or a global theme is simple and intuitive without having to manually manage dozens of classes."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "无痛维护：你永远不必寻找不同的文件来查找影响组件的样式，因此无论你的代码库有多大，维护都是小菜一碟。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Painless maintenance"
          }), ": you never have to hunt across different files to find the styling affecting your component, so maintenance is a piece of cake no matter how big your codebase is."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "自动浏览器前缀：按照当前标准编写 CSS，然后让样式组件处理其余的事情。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Automatic vendor prefixing"
          }), ": write your CSS to the current standard and let styled-components handle the rest."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "你可以获得所有这些好处，同时仍然编写你熟悉和喜爱的 CSS，只需绑定到各个组件即可。"
    }), "\n", _jsx(_components.p, {
      children: "¥You get all of these benefits while still writing the CSS you know and love, just bound to individual components."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
